module.exports = __webpack_public_path__ + "static/media/erro_zap.35f07391.png";